import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1a1a4fff"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"info-main\" data-v-1a1a4fff><p class=\"info-title\" data-v-1a1a4fff>使用目的</p><div class=\"info-desc\" data-v-1a1a4fff>用于埋点统计分析、安全风控</div></div><div class=\"info-main\" data-v-1a1a4fff><p class=\"info-title\" data-v-1a1a4fff>使用场景</p><div class=\"info-desc\" data-v-1a1a4fff>用户使用APP时</div></div><div class=\"info-main\" data-v-1a1a4fff><p class=\"info-title\" data-v-1a1a4fff>收集主体</p><div class=\"info-desc\" data-v-1a1a4fff>本APP</div></div>", 3);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_title = _resolveComponent("top-title");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_top_title, {
    onBack: $setup.back,
    title: "BSSID"
  }, null, 8, ["onBack"]), _hoisted_2])]);
}